import { Badge } from "@mantine/core";

const NoOverflowBadge = ({ children, ...props }) => (
  <Badge
    {...props}
    styles={{
      label: {
        overflow: "visible",
        textOverflow: "clip",
      },
    }}
  >
    {children}
  </Badge>
);

export default NoOverflowBadge;
